(function() {
  var MyTab;

  $(function() {
    return $("#main-content").children('.divide-content').on('click', function() {
      var content;
      content = $(this);
      $("#main-content").children(".active").removeClass("active").addClass("clickable");
      content.removeClass("clickable");
      return content.addClass("active");
    });
  });

  //①イージングなし
  $(function() {
    return $("#menu-toggle").on('click', function() {
      //    $("body").toggleClass("open")
      return $("#sp-menu").toggle(500);
    });
  });

  $(function() {
    return $('a[href^="#"]').on('click', function() {
      var target, targetY, time;
      time = 300;
      target = $(this.hash);
      if (!target.length) {
        return;
      }
      targetY = target.offset().top - 10;
      $('html,body').animate({
        scrollTop: targetY
      }, time, 'swing');
      return false;
    });
  });

  MyTab = class MyTab {
    basic(btn, contents) {
      var opentab;
      opentab = "." + btn.attr('data-tab');
      btn.siblings().removeClass('active');
      btn.addClass('active');
      btn.siblings('.tab-direction').show();
      btn.next('.tab-direction').hide();
      btn.prev('.tab-direction').hide();
      contents.children('.active').removeClass('active');
      return contents.children(opentab).addClass('active');
    }

  };

  $(function() {
    var myTab;
    myTab = new MyTab;
    $(".myTab").children('.tab-btn').on('click', function() {
      return myTab.basic($(this), $("#" + $(this).parent().attr('data-tab-area')));
    });
    return $(".myTab").children('.tab-direction').on('click', function() {
      var btn, now;
      now = $(this).siblings('.active');
      if ($(this).attr('data-direction') === 'prev') {
        btn = now.prev('.tab-btn');
      } else {
        btn = now.next('.tab-btn');
      }
      return myTab.basic(btn, $("#" + btn.parent().attr('data-tab-area')));
    });
  });

}).call(this);

//# sourceMappingURL=special.js.map
